export const formatAccountDisplay = (account) => {
  if (account) {
    return `${account?.substr(0, 6)}...${account?.substr(-6, 6)}`;
  }
  return account;
};
